import { library } from '@fortawesome/fontawesome-svg-core';

import {
	faAlignCenter,
	faAngleDown,
	faAngleUp,
	faArrowCircleDown,
	faArrowCircleLeft,
	faArrowCircleRight,
	faArrowCircleUp,
	faAsterisk,
	faAward,
	faBars,
	faBook,
	faBookReader,
	faCalendar,
	faCalendarAlt,
	faChalkboard,
	faChalkboardTeacher,
	faChartBar,
	faCheck,
	faChevronCircleLeft,
	faChevronDown,
	faChevronLeft,
	faChevronRight,
	faChevronUp,
	faClipboardList,
	faClock,
	faCogs,
	faColumns,
	faComment,
	faCommentDots,
	faCompress,
	faDollarSign,
	faDownload,
	faEdit,
	faEnvelope,
	faEquals,
	faExchangeAlt,
	faExclamation,
	faExclamationCircle,
	faExclamationTriangle,
	faExpand,
	faEye,
	faEyeSlash,
	faFile,
	faFileAlt,
	faFileArchive,
	faFileExcel,
	faFileExport,
	faFileImage,
	faFileImport,
	faFileMedical,
	faFilePdf,
	faFileSignature,
	faFileWord,
	faFilter,
	faFolder,
	faFolderOpen,
	faFont,
	faGavel,
	faGlobeAmericas,
	faGraduationCap,
	faHandPointer,
	faHandPointUp,
	faHome,
	faInfo,
	faInfoCircle,
	faLink,
	faListAlt,
	faListOl,
	faMinusCircle,
	faNotEqual,
	faPaperclip,
	faPencilAlt,
	faPhone,
	faPiggyBank,
	faPlayCircle,
	faPlus,
	faPrint,
	faQuestion,
	faQuestionCircle,
	faRandom,
	faRedo,
	faSave,
	faSchool,
	faSearch,
	faSlidersH,
	faSms,
	faSortAlphaDown,
	faSpinner,
	faSquare,
	faStar,
	faStream,
	faSync,
	faTh,
	faTimes,
	faToolbox,
	faTrash,
	faUndo,
	faUser,
	faUserGraduate,
	faUtensils
} from '@fortawesome/free-solid-svg-icons';

library.add(faAlignCenter);
library.add(faAngleDown);
library.add(faAngleUp);
library.add(faArrowCircleDown);
library.add(faArrowCircleLeft);
library.add(faArrowCircleRight);
library.add(faArrowCircleUp);
library.add(faAsterisk);
library.add(faAward);
library.add(faBars);
library.add(faBook);
library.add(faBookReader);
library.add(faCalendar);
library.add(faCalendarAlt);
library.add(faChalkboard);
library.add(faChalkboardTeacher);
library.add(faChartBar);
library.add(faCheck);
library.add(faChevronCircleLeft);
library.add(faChevronDown);
library.add(faChevronLeft);
library.add(faChevronRight);
library.add(faChevronUp);
library.add(faClipboardList);
library.add(faClock);
library.add(faCogs);
library.add(faColumns);
library.add(faComment);
library.add(faCommentDots);
library.add(faCompress);
library.add(faDollarSign);
library.add(faDownload);
library.add(faEdit);
library.add(faEnvelope);
library.add(faEquals);
library.add(faExchangeAlt);
library.add(faExclamation);
library.add(faExclamationCircle);
library.add(faExclamationTriangle);
library.add(faExpand);
library.add(faEye);
library.add(faEyeSlash);
library.add(faFile);
library.add(faFileAlt);
library.add(faFileArchive);
library.add(faFileExcel);
library.add(faFileExport);
library.add(faFileImage);
library.add(faFileImport);
library.add(faFileMedical);
library.add(faFilePdf);
library.add(faFileSignature);
library.add(faFileWord);
library.add(faFilter);
library.add(faFolder);
library.add(faFolderOpen);
library.add(faFont);
library.add(faGavel);
library.add(faGlobeAmericas);
library.add(faGraduationCap);
library.add(faHandPointer);
library.add(faHandPointUp);
library.add(faHome);
library.add(faInfo);
library.add(faInfoCircle);
library.add(faLink);
library.add(faListAlt);
library.add(faListOl);
library.add(faMinusCircle);
library.add(faNotEqual);
library.add(faPaperclip);
library.add(faPencilAlt);
library.add(faPhone);
library.add(faPiggyBank);
library.add(faPlayCircle);
library.add(faPlus);
library.add(faPrint);
library.add(faQuestion);
library.add(faQuestionCircle);
library.add(faRandom);
library.add(faRedo);
library.add(faSave);
library.add(faSchool);
library.add(faSearch);
library.add(faSlidersH);
library.add(faSms);
library.add(faSortAlphaDown);
library.add(faSpinner);
library.add(faSquare);
library.add(faStar);
library.add(faStream);
library.add(faSync);
library.add(faTh);
library.add(faTimes);
library.add(faToolbox);
library.add(faTrash);
library.add(faUndo);
library.add(faUser);
library.add(faUserGraduate);
library.add(faUtensils);
